import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import draggable from 'vuedraggable';
import store from '@/store';

import type { ListElements } from '@/typings/customilyElements/layer';
import LayersTreeItem from './LayersTreeItem.vue';
import LayersTreeItemEps from '@/components/Layers/tree/item/eps/LayersTreeItemEps.vue';
import LayersTreeItemGroup from '@/components/Layers/tree/item/group/LayersTreeItemGroup.vue';
import LayersTreeItemElement from '@/components/Layers/tree/item/element/LayersTreeItemElement.vue';
import { useLayersDraggable, type MoveEvent } from '@/components/Layers/composables/layerDraggable';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersTreeItem',
  props: {
    value: null
  },
  emits: ["update:modelValue", "tree-item-moved"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', value: ListElements[]): void;
    (event: 'tree-item-moved'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: ListElements;
};





const {
    pageEpsElements,
    dragOptions,
    handleMove,
    getItemKey,
    handleChange
} = useLayersDraggable();

const isCollapsed = ref(props.value.type === 'PageEps' ? true : false);

const itemChildren = computed(() => props.value.children);
const hasChildren = computed(() => itemChildren.value && itemChildren.value.length > 0);

const isPageEps = computed(() => props.value.type === 'PageEps');
const shouldHideWrapper = computed(() => pageEpsElements.value && pageEpsElements.value?.length <= 1);

const itemComponent = computed(() => {
    const componentTypes = {
        PageEps: LayersTreeItemEps,
        Group: LayersTreeItemGroup,
        CanvasElement: LayersTreeItemElement,
        default: LayersTreeItemElement
    };

    return componentTypes[props.value.type] || componentTypes.default;
});

const toggleCollapse = () => {
    isCollapsed.value = !isCollapsed.value;
};

const onMove = (event: MoveEvent) => {
    return handleMove(event);
};

const handleDragEnd = () => {
    emit('tree-item-moved');
    store.dispatch('storeLayers/setDraggedItem', {
        currentDraggedItem: undefined,
        currentTargetItem: undefined,
    });
};

const onChangeHandler = () => {
    handleChange();
};

const emitModelUpdate = (value: ListElements[]) => {
    emit('update:modelValue', value);
};

return { __sfc: true,props, emit, pageEpsElements, dragOptions, handleMove, getItemKey, handleChange, isCollapsed, itemChildren, hasChildren, isPageEps, shouldHideWrapper, itemComponent, toggleCollapse, onMove, handleDragEnd, onChangeHandler, emitModelUpdate, draggable, LayersTreeItem }
}

})